import { render, staticRenderFns } from "./ShopHome.vue?vue&type=template&id=546729fd&scoped=true"
import script from "./ShopHome.vue?vue&type=script&lang=js"
export * from "./ShopHome.vue?vue&type=script&lang=js"
import style1 from "./ShopHome.vue?vue&type=style&index=1&id=546729fd&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546729fd",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection});
